import React from 'react';
import { styled } from 'styled-components';
import { BREAKPOINTS } from '../../../styles/variables';

const VideoBlock = ({ data }) => {
  return (
    <VideoBlockWr>
      <Video src={data} controls />
    </VideoBlockWr>
  );
};

const VideoBlockWr = styled.section`
  margin: 0 0 24px;

  @media ${BREAKPOINTS.laptop} {
    margin: 0 0 1.67vw;
  }
  @media ${BREAKPOINTS.mobile} {
    margin: 0 0 5.83vw;
  }
`;

const Video = styled.video`
  width: 100%;
  border-radius: 28px;
  object-fit: cover;

  @media ${BREAKPOINTS.laptop} {
    border-radius: 1.94vw;
  }
  @media ${BREAKPOINTS.mobile} {
    border-radius: 5.83vw;
  }
`;

export default VideoBlock;
